<template>
    <div class="biz-recomand-pc">
        <div class="landing-container wrap">
            <div class="dot"></div>
            <carousel class="recomand-carousel" :autoplay="false" :nav="false" :dots="false" :responsive="responsiveSetting">
                <template slot="prev"><span class="prev"><img src="@/assets/img/landingPage/recommand/recommand_arrow_gray.svg" alt="" srcset=""></span></template>
                <template slot="next"><span class="next"><img src="@/assets/img/landingPage/recommand/recommand_arrow_red.svg" alt="" srcset=""></span></template>
                <div class="recomand">
                    <div class="shot">
                        <img src="@/assets/img/landingPage/shot/2.svg" alt="">
                    </div>
                    <div class="info">
                        <div class="stars">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        </div>
                        <div class="name">
                            誠毅物業管理顧問股份有限公司
                        </div>
                        <div class="description">
                            這是第一個使用過後，最貼近我們想要的系統，符合短期月租的需求。飛豬管家與我們公司理念有很多相近之處，都是希望提供全新的服務模式，期許這系統能越來越好用！
                        </div>
                    </div>
                </div>
                <div class="recomand">
                    <div class="shot">
                        <img src="@/assets/img/landingPage/shot/4.svg" alt="">
                    </div>
                    <div class="info">
                        <div class="stars">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        </div>
                        <div class="name">
                            皇嘉物業管理股份有限公司
                        </div>
                        <div class="description">
                            很高興成為首批加入使用的企業，飛豬管家刊登廣告滿簡單的，而且免費，也可以在房客退租後銜接上新的房客，不會產生空窗期！而且報表功能很強大，非常好用！
                        </div>
                    </div>
                </div>
                <div class="recomand">
                    <div class="shot">
                        <img src="@/assets/img/landingPage/shot/7.svg" alt="">
                    </div>
                    <div class="info">
                        <div class="stars">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                            <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        </div>
                        <div class="name">
                            家成物業管理顧問公司
                        </div>
                        <div class="description">
                            像是免費幫自己公司架設了一個推廣網站，功能滿齊全的，重要的是提前出租的效果，讓公司大大降低成本管銷支出！值得分享推薦！
                        </div>
                    </div>
                </div>
            </carousel>
        </div>
    </div>
</template>
<script>
import carousel from 'vue-owl-carousel'
export default {
    data () {
        return{
            responsiveSetting: {
                0: {
                    margin: 31,
                    items: 2.5,
                },
                576: {
                    margin: 31,
                    items: 2.5,
                },
                992: {
                    margin: 31,
                    items: 2.5,
                },
            },
        }
    },
    mounted(){
        // setTimeout(() => {
        //     let ids = document.querySelectorAll('*[id^="carousel_prev"]');
        //     Array.prototype.forEach.call(ids, callback);

        //     function callback(element, iterator) {
        //         document.getElementById(element.id).style.display = 'block';
        //     }
        // }, 1000)
    },
    methods: {
       
    },
    components: {
        carousel
    }
}
</script>
<style lang="scss" scoped>
    .biz-recomand-pc{
        background-color:#f7f7f7;
        display: flex;
        justify-content: center;
        .wrap{
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 85px 0;
            .recomand-carousel{
                width: 100%;
            }
            .dot{
                background: #e0dfde;
                position: absolute;
                width: 17px;
                height: 7px;
                border-radius: 20px;
                bottom: 43px;
                left: 48.6%;
            }
            .prev,
            .next{
                position: absolute;
                bottom: 35px;
                cursor: pointer;
            }
            .prev{
                left: 42.6%;
            }
            .next{
                right: 42.6%;
            }
            .recomand{
                display: flex;
                align-items: flex-start;
                .shot{
                    width: 130px;
                    height: 130px;
                    border-radius: 50%;
                    // background: #000;
                    margin-right: 24px;
                    img{
                        width: 130px;
                        height: 130px;
                    }
                }
                .info{
                    width: 228px;
                    .stars{
                        display: flex;
                        align-content: center;
                        margin-bottom: 10px;
                        >img{
                            width: 20px;
                            margin-right: 6px;
                        }
                    }
                    .name{
                        font-size: 24px;
                        font-weight: 500;
                        color: #353535;
                        margin-bottom: 10px;
                    }
                    .description{
                        font-size: 16px;
                        color: #353535;
                        line-height: 1.5;
                    }
                }
            }
            .biz-recomand-pc-prev{
                position: absolute;
                top: 30%;
                z-index: 2;
                left: -20px;
                img {
                width: 40px;
                height: 40px;
                }
            }
            .biz-recomand-pc-next{
                position: absolute;
                top: 30%;
                z-index: 2;
                right: -20px;
                img {
                width: 40px;
                height: 40px;
                }
            }
        }
    }
    @media screen and (max-width: 1100px) {
       .biz-recomand-pc{
           display: none;
       }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/bussiness/recomandPc.vue